import FiltersHeader from './FiltersHeader';

export default FiltersHeader;
